// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8877) return "static/chunks/8877-8931bafc81431ff6.js";
	if (chunkId === 4553) return "static/chunks/4553-c6016c528e4ab845.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 806 ? "4163ae0c" : chunkId) + "." + {"521":"a9f28947f3c97940","806":"3fc78e78c1cf6ac9","1331":"e9128d032f9b8f64","1657":"67a90b4833cb0cb4","8204":"ce1f8bb713c8bc9f","8270":"2fba79b72cc3c1aa","8964":"2cdae35434d89cea","9174":"ba9024188bc84682","9318":"dc8326188bbb5564"}[chunkId] + ".js";
};